// extracted by mini-css-extract-plugin
export default {"container":"GeneralEnergyTab_container__g+Kit"};